import React, { useEffect, useState } from 'react';
import { Usepopularcolorcontext } from "../../utils/Hooks/Color-explorer";
import Container from '@mui/material/Container';
import "../../component/styles/styles.scss";
import Grid from '@mui/material/Grid';
import Loader from '../../component/loader';
import Randomshades from "./Randomshades";
import ScrollToTop from "react-scroll-to-top";
import tinycolor from 'tinycolor2';
import Appbutton from '../../component/button';

export default function Explorer() {
    const { useGetPopularColors, storeSpecificColor, dataLoader, storeRandomColor, mutateInputValue, storeColorTagName,
        setStoreColorTagName, setStoreActiveId, storeActiveId, copy, handleColors } = Usepopularcolorcontext();

    const { isLoading } = useGetPopularColors();

    const handleColorTab = (colorInfo) => {
        mutateInputValue(colorInfo.colorName);
        setStoreColorTagName(colorInfo.colorName);
        setStoreActiveId(colorInfo.colorId);
    }

    useEffect(() => {

        return () => {
            setStoreActiveId(0);
        }
    }, [])

    const generateColorShades = (colorHexCode) => {
        const color = tinycolor(colorHexCode);
        var colors = tinycolor(colorHexCode).monochromatic();
        console.log(colors, "===== colors");
        const shades = [];

        // Generate shades using tinycolor2
        for (let i = 0; i <= 5; i++) {
            const shade = color.darken(i * 3).desaturate(1 * 3).toString();
            shades.push(shade);
        }

        return shades;
    };



    return (
        <>
            {dataLoader || isLoading ? <Loader /> : (
                <Container maxWidth="xl">
                    <div className="red-color-pallete-wrapper">
                        <h1 className="text-red-500">
                            Randoms
                        </h1>
                        <p>Dive into a stunning array of {storeActiveId === 0 ? "Random" : storeColorTagName}  colors for your next project.</p>
                        <p>OR</p>
                        <p>Get specific shades of the color you need.</p>
                        <Randomshades handleColorTab={handleColorTab} />
                        <p>Click to copy!</p>
                        <div className='random-color-wrapper'>
                            <Grid container spacing={3}>
                                {storeActiveId === 0 ? (
                                    storeRandomColor && storeRandomColor.map((colorCode, index) => {
                                        const shades = generateColorShades(colorCode.hex);
                                        return (
                                            <Grid item xs={3} key={index}>
                                                <div
                                                    className="redColor-wrapper"
                                                >
                                                    {shades.map((shade, index) => (
                                                        <div
                                                            className="color-shade"
                                                            key={index}
                                                            style={{ backgroundColor: shade }}
                                                            onClick={() => handleColors(shade)}
                                                        >
                                                            {copy === shade ? <h5>Copied!</h5> : ""}
                                                            <p>{shade}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Grid>
                                        );
                                    })
                                ) : (
                                    storeSpecificColor && storeSpecificColor.map((colorCode, index) => {
                                        const shades = generateColorShades(colorCode.hex);
                                        return (
                                            <Grid item xs={3} key={index}>
                                                <div
                                                    className="redColor-wrapper"
                                                >
                                                    {shades.map((shade, index) => (
                                                        <div
                                                            className="color-shade"
                                                            key={index}
                                                            style={{ backgroundColor: shade }}
                                                            onClick={() => handleColors(shade)}
                                                        >
                                                            {copy === shade ? <h5>Copied!</h5> : ""}
                                                            <p>{shade}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Grid>
                                        );
                                    })
                                )}
                            </Grid>
                        </div>
                    </div>
                    <ScrollToTop smooth color="#111" top="1000" />
                </Container>
            )}
        </>
    )
}
